/**
 * URL-param helpers for tag-filter sets.
 *
 * Tag filter sets are stored in the URL as a comma-separated string
 * (`?tags=a,b,c`) rather than a JSON-encoded array. That keeps shared URLs
 * human-readable and avoids TanStack Router's default `?tags=["a","b"]`
 * serialisation for array search params.
 */

export function splitTags(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function joinTags(tags: readonly string[]): string | undefined {
  return tags.length > 0 ? tags.join(",") : undefined;
}
